import includes from "lodash/includes";

export const allDisabled = (assets) => {
  const nonEmptyAssets = (assets || []).filter((a) => !!a);

  return (
    !nonEmptyAssets.length || nonEmptyAssets.some((a) => includes(["public", "private"], a.status))
  );
};

export const customDisabled = (assets) => {
  const nonEmptyAssets = (assets || []).filter((a) => !!a);

  return !nonEmptyAssets.length || nonEmptyAssets.some((a) => a.status === "private");
};

export const defaultShareStatus = (assets, isBroker = false) =>
  assets.length && assets.every((a) => a.status === "invite") // eslint-disable-line
    ? "all"
    : isBroker
    ? "broker_owner_team"
    : "owner_team";

export const updateShareStatus = (assets = [], status, isBroker = false) =>
  !assets.length ||
  (status === "custom" && customDisabled(assets)) ||
  (status === "all" && allDisabled(assets)) ||
  (status !== "custom" && isBroker)
    ? defaultShareStatus(assets, isBroker)
    : status;
